export default {
  CHAIR: {
    SHOW: "/api/settings",
  },
  DOCUMENT: {
    INDEX: "/api/documents",
  },
  EVENT: {
    INDEX: "/api/events",
    SHOW: "/api/events/:event",
  },
  NEWS: {
    INDEX: "/api/news",
    SHOW: "/api/news/:news",
  },
  PAGE: {
    INDEX: "/api/pages",
    SHOW: "/api/pages/:page",
  },
  POST: {
    INDEX: "/api/posts",
  },
};
